import { render, staticRenderFns } from "./CreateMonitor.vue?vue&type=template&id=9dfb42fc"
import script from "./CreateMonitor.vue?vue&type=script&lang=js"
export * from "./CreateMonitor.vue?vue&type=script&lang=js"
import style0 from "./CreateMonitor.vue?vue&type=style&index=0&id=9dfb42fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports